/* @flow */

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    width: '100%',
    paddingTop: 30,
    paddingBottom: 30,
  },
  stepperSteps: {
    marginBottom: 0,
  },
  stepCircle: {
    backgroundColor: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  stepLabel: {
    color: ({ theme }: ThemeFunction) => theme.textColorSecondary,
  },
};
